import IconBold from "../../../public/images/bold.svg";
import EditorPanelButton from "./EditorPanelButton";
import {useCallback} from "react";
import useObjectEditStore from "../../../store/useObjectEditStore";

const BoldButton = () => {
  const objectEditStore = useObjectEditStore();

  const handleBoldTextClick = useCallback(() => {
    const objectEdit = () => {
      const element = objectEditStore.objectEdit.element;
      const weight = objectEditStore.objectEdit.weight === 'bold' ? 'normal' : 'bold';
      element.style.fontWeight = weight;
      return {
        ...objectEditStore.objectEdit,
        weight: weight,
      };
    }
    objectEditStore.setObjectEdit(objectEdit());
  }, [objectEditStore.objectEdit]);

  return (
    <EditorPanelButton onClick={handleBoldTextClick} icon={IconBold}/>
  );
};

export default BoldButton;
